import React from "react";
import { Badge } from "reactstrap";

export const getBookingColumns = ({ onDeleteClick, onEditClick, onRowClick, onInvoiceClick, onInvoiceViewClick, onPaymentStatusClick }) => {
  return [
    {
      name: <span className="font-weight-bold fs-13"></span>,
      selector: (row) => row.paymentStatus,
      sortable: false,
      width: "60px",
      cell: (row) => {
        const status = (row.paymentStatus || 'incomplete').toLowerCase();
        const iconMap = { paid: '✅', partial: '🚸', cancel: '❌', incomplete: '❓' };
        const icon = iconMap[status] ?? '❓';
        const titleMap = { partial: 'Outstanding', cancel: 'Cancel', incomplete: 'Incomplete', paid: 'Paid' };
        const title = titleMap[status] ?? status.charAt(0).toUpperCase() + status.slice(1);
        return (
          <div className="d-flex align-items-center justify-content-center w-100 py-2">
            <span className="d-inline-flex align-items-center justify-content-center" style={{ fontSize: '1.5rem', lineHeight: 1 }} title={title}>
              {icon}
            </span>
          </div>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Booking Dates</span>,
      selector: (row) => `${row.startDate || row.bookingDate || ''} - ${row.endDate || row.bookingEndDate || ''}`,
      sortable: false,
      minWidth: "220px",
      grow: 2,
      cell: (row) => {
        const formatDate = (d) => {
          if (!d) return "N/A";
          const dt = new Date(d);
          if (isNaN(dt)) return d;
          const dd = String(dt.getDate()).padStart(2, "0");
          const mm = String(dt.getMonth() + 1).padStart(2, "0");
          const yyyy = dt.getFullYear();
          return `${dd}-${mm}-${yyyy}`;
        };

        const startDate = row.startDate || row.bookingDate;
        const endDate = row.endDate || row.bookingEndDate;

        return (
          <div className="cursor-pointer w-100" onClick={() => onRowClick(row)}>
            <span className="fw-medium">{formatDate(startDate)} to {formatDate(endDate)}</span>
          </div>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">User</span>,
      selector: (row) => row.user?.name || row.userName,
      sortable: false,
      minWidth: "140px",
      grow: 1.5,
      cell: (row) => (
        <div className="cursor-pointer w-100" onClick={() => onRowClick(row)}>
          <span className="fw-medium">{row.user?.name || row.userName}</span>
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Farmhouse</span>,
      selector: (row) => row.farmhouse?.name || row.farmhouseName,
      sortable: false,
      minWidth: "140px",
      grow: 1.5,
      cell: (row) => (
        <div className="cursor-pointer w-100" onClick={() => onRowClick(row)}>
          <span className="fw-medium">{row.farmhouse?.name || row.farmhouseName || "N/A"}</span>
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Payment Status</span>,
      selector: (row) => row.paymentStatus,
      sortable: false,
      width: "140px",
      cell: (row) => {
        const getPaymentBadgeColor = (paymentStatus) => {
          switch (paymentStatus) {
            case 'paid': return 'success';
            case 'partial': return 'warning';
            case 'incomplete': return 'danger';
            case 'cancel': return 'danger';
            default: return 'secondary';
          }
        };

        const paymentStatus = row.paymentStatus || 'incomplete';

        return (
          <div
            className="d-flex align-items-center w-100 cursor-pointer"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onPaymentStatusClick(row);
            }}
          >
            <Badge color={getPaymentBadgeColor(paymentStatus)} className="fw-medium">
              {paymentStatus === 'partial' ? 'OUTSTANDING' : paymentStatus.toUpperCase()}
            </Badge>
          </div>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Actions</span>,
      width: "190px",
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center gap-2 farmhouse-action-group">
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onInvoiceClick && onInvoiceClick(row);
            }}
            className="text-decoration-none px-1 py-2 cursor-pointer farmhouse-action-btn"
            title="Download Invoice"
          >
            <i className="ri-download-2-fill fs-13 text-info p-2 rounded-circle shadow-sm bg-f1 farmhouse-action-icon" />
          </div>
          {(row.user?.mobileNo || row.userMobileNo || row.user?.mobile || row.mobileNo) && (
            <a
              href={`tel:${row.user?.mobileNo || row.userMobileNo || row.user?.mobile || row.mobileNo}`}
              onClick={(event) => {
                event.stopPropagation();
              }}
              className="text-decoration-none px-1 py-2 cursor-pointer farmhouse-action-btn"
              title="Call Client"
            >
              <i className="ri-phone-fill fs-13 text-success p-2 rounded-circle shadow-sm bg-f1 farmhouse-action-icon" />
            </a>
          )}
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onEditClick && onEditClick(row);
            }}
            className="text-decoration-none px-1 py-2 cursor-pointer farmhouse-action-btn"
            title="Edit"
          >
            <i className="ri-pencil-fill fs-13 text-primary p-2 rounded-circle shadow-sm bg-f1 farmhouse-action-icon" />
          </div>
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onDeleteClick && onDeleteClick(row);
            }}
            className="text-decoration-none px-1 py-2 cursor-pointer farmhouse-action-btn"
            title="Delete"
          >
            <i className="ri-delete-bin-7-fill fs-13 text-danger p-2 rounded-circle shadow-sm bg-f1 farmhouse-action-icon" />
          </div>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: false,
      button: false,
    },
  ];
};